import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Zoom } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import  '../../assets/scss/v0/ImageSlider.scss';
import useWindowSize from '../../hooks/useWindowSize';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';


const images = [
  "https://sit2.bmktech.vn/resources/images/haibv/DSC03255.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC03219.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC03182.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC03144.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC03027.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC02924.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC02725.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC02665.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC02596.JPG",
  "https://sit2.bmktech.vn/resources/images/haibv/DSC02490.JPG",
];

Modal.setAppElement('#root');

const ImageSlider = () => {
  const windowSize = useWindowSize();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const closeModal = () => setModalIsOpen(false);
  const prevImage = () => {
    setPhotoIndex((photoIndex + images.length - 1) % images.length)
  };
  const nextImage = () => setPhotoIndex((photoIndex + 1) % images.length);

  return (
    <div className="swiper-container">
      {/*<div className='title'> */}
      {/*  ALBUM ẢNH*/}
      {/*</div>*/}
      <Swiper
        centeredSlides={true}
        zoom={true}
        slidesPerView={windowSize.width <= 768 ? 1 : 4}
        spaceBetween={80}
        loop={true}
        pagination={{
          clickable: true,
        }}
        modules={[Navigation, Zoom,Autoplay]}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        effect="coverflow"
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2,
          slideShadows: false,
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        className="mySwiper"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`img${index + 1}`}
              onClick={() => {
                setPhotoIndex(index);
                setModalIsOpen(true);
              }}
              style={{ cursor: 'pointer' }}
            />
          </SwiperSlide>
        ))}

        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </Swiper>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Image Lightbox"
        style={{
          
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 9999
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: 'none',
            border: 'none',
            padding: 0,  // Thêm padding: 0
            overflow: 'visible',  // Thêm overflow: visible
            zIndex: 10000  // Tăng z-index cho content
          }
        }}
      >
        <div style={{position: 'relative'}}>
          <img src={images[photoIndex]} alt={`Full size img${photoIndex + 1}`} style={{maxWidth: '90vw', maxHeight: '90vh'}} />
          <button onClick={prevImage} style={{position: 'absolute', left: '10px', top: '50%', background: 'none', border: 'none', color: 'white', fontSize: '2rem', cursor:'pointer'}}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button onClick={nextImage} style={{position: 'absolute', right: '10px', top: '50%', background: 'none', border: 'none', color: 'white', fontSize: '2rem', cursor:'pointer'}}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
          <button onClick={closeModal} style={{position: 'absolute', right: '10px', top: '10px', background: 'none', border: 'none', color: 'white', fontSize: '2rem', cursor:'pointer'}}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ImageSlider;